import logo1 from "@/assets/images/logos/rp-cve.svg";
import logo2 from "@/assets/images/logos/rp-cvss.svg";
import logo3 from "@/assets/images/logos/rp-cwe.svg";
import logo4 from "@/assets/images/logos/rp-owasp.png";

export const ReportingStandardSectionData = {
  heading: "Reporting Standard",
  description: (
    <>
      <p>
        Our reports follow industry standards, providing clear and actionable
        insights for enhancing thick client application security.
      </p>
    </>
  ),
  logos: [
    { src: logo1.src, alt: "cve" },
    { src: logo2.src, alt: "cvss" },
    { src: logo3.src, alt: "cve" },
    { src: logo4.src, alt: "owasp" },
  ],
};
